import { createContext } from 'react';

const useSamplingContext = createContext();
export default useSamplingContext;
